module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0015.jpg?v=d8ea4ded";